<table class="border-separate w-full" style="border-spacing: 0" role="grid">
  <thead aria-hidden="true">
    <tr>
      <th class="text-center pt-0 pb-[6px] px-0" colspan="4"></th>
    </tr>
  </thead>
  <tbody
    mat-calendar-body
    [label]="_yearLabel"
    [rows]="_months"
    [todayValue]="_todayMonth!"
    [startValue]="_selectedMonth!"
    [endValue]="_selectedMonth!"
    [labelMinRequiredCells]="2"
    [numCols]="4"
    [cellAspectRatio]="4 / 7"
    [activeCell]="_dateAdapter.getMonth(activeDate)"
    (selectedValueChange)="_monthSelected($event)"
    (activeDateChange)="_updateActiveDate($event)"
    (keyup)="_handleCalendarBodyKeyup($event)"
    (keydown)="_handleCalendarBodyKeydown($event)"
  ></tbody>
</table>
